import React from 'react'
import './StepProgressBar.scss'
import Step from './Step/Step'

/**
 * This StepProgressBar component is exactly the same as simple StepProgressBar. The only difference is
 * that this component is being used on forms instead of dialog.
 * @component
 * @memberof Components
 * @returns {JSX.Element} The StepProgressBar component containing multiple steps.
 */

const StepProgressBar = (props) => {
    return (
        <div className="container-step">
            <div className="arrow-steps clearfix">
                {props.array.map((item, index) => (
                    <Step key={index} number={index + 1} title1={item.title1} title2={item.title2} status={item.status} />
                ))}
            </div>
        </div>
    )
}

export default StepProgressBar